import React from 'react'
import PropTypes from 'prop-types'
import shouldUpdate from 'recompose/shouldUpdate'
import DatagridCell from './DatagridCell'

import { TableRow } from '@/ui/Table'

const DatagridBody = ({
  resource,
  children,
  ids,
  data,
  isLoading,
  options,
  rowOptions,
  startingNo = 0,
  theme,
  ...rest
}) => (
  <tbody className={theme['datagrid-body']} {...rest} {...options}>
    {ids.map((id, rowIndex) => (
      <TableRow key={id} selectable={false} {...rowOptions}>
        {React.Children.map(children, (field, index) => {
          return (
            <DatagridCell
              theme={theme}
              key={`${id}-${field.props.source || index}`}
              classes={`column-${field.props.source || field.props.cellName || 'simple'}`}
              record={data[id]}
              index={startingNo + rowIndex}
              {...{ field, resource }}
            />
          )
        })}
      </TableRow>
    ))}
  </tbody>
)

DatagridBody.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool,
  resource: PropTypes.string,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  rowOptions: PropTypes.object,
}

DatagridBody.defaultProps = {
  data: {},
  ids: [],
}

const PureDatagridBody = shouldUpdate((props, nextProps) => nextProps.isLoading === false)(
  DatagridBody,
)

export default PureDatagridBody



// WEBPACK FOOTER //
// ./ui/DataTable/DatagridBody.js